<template>
  <nav
    v-if="pageCount > 1"
    class="mobile-pager"
    aria-label="移动端分页"
  >
    <button
      type="button"
      class="mobile-pager__button"
      :class="{ 'is-disabled': currentPage <= 1 }"
      :disabled="currentPage <= 1"
      aria-label="上一页"
      @click="changePage(currentPage - 1)"
    >
      &lt;
    </button>
    <template v-for="(page, index) in pageNumbers">
      <span
        v-if="page === '...'"
        :key="`ellipsis-${index}`"
        class="mobile-pager__ellipsis"
        aria-hidden="true"
      >...</span>
      <button
        v-else
        :key="page"
        type="button"
        class="mobile-pager__page"
        :class="{ 'is-active': page === currentPage }"
        :aria-current="page === currentPage ? 'page' : null"
        :aria-label="`第 ${page} 页`"
        @click="changePage(page)"
      >
        {{ page }}
      </button>
    </template>
    <button
      type="button"
      class="mobile-pager__button"
      :class="{ 'is-disabled': currentPage >= pageCount }"
      :disabled="currentPage >= pageCount"
      aria-label="下一页"
      @click="changePage(currentPage + 1)"
    >
      &gt;
    </button>
  </nav>
</template>

<script>
import { getPageNumbers } from '@/utils/dashboardPresentation'

export default {
  name: 'MobilePager',
  model: {
    prop: 'currentPage',
    event: 'change',
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.pageSize)
    },
    pageNumbers() {
      return getPageNumbers(this.currentPage, this.pageCount)
    },
  },
  watch: {
    pageCount(count) {
      if (count > 0 && this.currentPage > count) this.$emit('change', count)
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.pageCount || page === this.currentPage) return
      this.$emit('change', page)
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-pager {
  display: none;
}

@media (max-width: 768px) {
  .mobile-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-top: 16px;
    padding: 8px 4px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-pager__button,
  .mobile-pager__page,
  .mobile-pager__ellipsis {
    flex: 0 0 auto;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin-right: 6px;
    line-height: 1;
    font-size: 13px;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-pager__button,
  .mobile-pager__page {
    min-width: 32px;
    padding: 0 4px;
    border-radius: 6px;
    border: 1px solid transparent;
    background: transparent;
    color: #606266;
    font-weight: 500;
    cursor: pointer;
  }

  .mobile-pager__button {
    width: 32px;
    padding: 0;
    border-color: #dcdfe6;
    background: #fff;
    font-weight: 600;
  }

  .mobile-pager__button.is-disabled {
    border-color: #ebeef5;
    background: #f5f7fa;
    color: #c0c4cc;
    cursor: not-allowed;
  }

  .mobile-pager__page.is-active {
    border-color: #409eff;
    background: #409eff;
    color: #fff;
    font-weight: 600;
  }

  .mobile-pager__ellipsis {
    width: 24px;
    color: #909399;
    letter-spacing: 2px;
  }

  .mobile-pager > :last-child {
    margin-right: 0;
  }
}
</style>
